export default __webpack_public_path__ + "static/media/correios.892b742e.svg";